'use client'

import { useEffect, useState } from 'react'
import store, { handleGlobal } from '@/(front-desk)/store'
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline'
import { CheckIcon } from '@heroicons/react/20/solid'
import * as Sentry from "@sentry/nextjs"
import classNames from 'classnames'
import Link from 'next/link'

export default function Error({ error, reset, id }) {

    const SENTRY_DSN = process.env.SENTRY_DSN
    const dispatch = store.dispatch
    const [ eventId, setEventId ] = useState(id || Sentry.lastEventId() || null)
    const [ copy, setCopy ] = useState(false)

    useEffect(() => {
        document.body.style.overflow = 'hidden'

        return () => {
            document.body.style.overflow = 'auto'
        }
    }, [])

    useEffect(() => {
        if (SENTRY_DSN && error && !eventId) {
            Sentry.captureException(error)
            const sentryEventId = Sentry.captureException(error)
            setEventId(sentryEventId)
        }
    }, [error])

    return (
        <main className="mt-0 flex-center flex-col absolute full inset-0 z-10 bg-black text-white">
            <h1 className="text-2xl mb-2">發生了一些錯誤</h1>
            <div className="mb-2">請稍後再嘗試一次</div>
            { eventId &&
                <div
                    className="group px-6 relative flex-center cursor-pointer"
                    onClick={() => {
                        navigator.clipboard.writeText(eventId)
                        .then((e) => {
                            setCopy(true)
                        })
                    }}
                >
                    <div className="text-[0.75rem] text-black-500">
                        {eventId}
                    </div>
                    <div className="absolute right-0">
                        <DocumentDuplicateIcon
                            className={classNames('w-5 stroke-white hidden', {
                                'group-hover:!block': !copy,  
                            })}
                        />
                        <CheckIcon
                            className={classNames('w-4 fill-white hidden', {
                                '!block': copy
                            })}
                        />
                    </div>
                </div>
            }
            <Link
                href="/"
                className="btn btn-main btn-round mt-12"
                onClick={() => {
                    dispatch(handleGlobal.actions.setSentryErrorEventId(null))
                }}
            >返回首頁</Link>
        </main>
    )
}